import { githubAppEndpoints } from '@playbooks/components/github/github-app';
import { GithubRedirectBtn } from '@playbooks/components/github/github-redirect-btn';

const GithubAuthBtn = ({
	referralCode = null,
	intent = 'authenticate',
	onNext,
	children = 'Continue with GitHub',
	...props
}) => {
	return (
		<GithubRedirectBtn
			variant='accent'
			size='lg'
			prevIcon={{ type: 'fab', icon: 'github' }}
			url={githubAppEndpoints.authorize}
			params={{ intent, referralCode }}
			popup
			onNext={onNext}
			className='w-full'
			{...props}>
			{children}
		</GithubRedirectBtn>
	);
};

export { GithubAuthBtn };
